import { createContainer } from 'react-sweet-state';

import {
  type Actions,
  type ContainerProps,
  MainStore,
  PRIVATE_ACTIONS,
  type State,
} from './MainStore';

export const MainStoreContainer = createContainer<State, Actions, ContainerProps>(MainStore, {
  onInit:
    () =>
    ({ dispatch }, { authorizeUrl }) => {
      dispatch(PRIVATE_ACTIONS.init(authorizeUrl));
    },
});
